<template>
    <el-card shadow="never">
        <div v-if="isExporting" class="export-progress">
            <el-progress :percentage="exportProgress" status="success" text-inside :stroke-width="6"></el-progress>
            <div class="progress-text">导出中，请等待...</div>
        </div>
        <div class="search">
            <!-- 输入搜索关键字表单 -->
            <el-form :model="searchForm" ref="formRef" label-width="120px" label-position="right">
                <el-row :gutter="16">
                    <template v-for="item in searchConfig.formItems" :key="item.prop">
                        <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8"> -->
                        <el-form-item :label="item.label" :prop="item.prop">
                            <template v-if="item.type === 'input'">
                                <el-input v-model="searchForm[item.prop]" :placeholder="item.placeholder"
                                    style="width: 220px;" clearable></el-input>
                            </template>
                            <template v-if="item.type === 'date-picker'">
                                <el-date-picker v-model="searchForm[item.prop]" type="datetime"
                                    format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"
                                    :placeholder="item.placeholder" style="width: 220px;" />
                            </template>
                            <template v-if="item.type === 'date-picker-day'">
                                <el-date-picker v-model="searchForm[item.prop]" type="date" format="YYYY-MM-DD"
                                    value-format="YYYY-MM-DD" :placeholder="item.placeholder" style="width: 220px;" />
                            </template>
                            <template v-if="item.type === 'select'">
                                <el-select v-model="searchForm[item.prop]" :placeholder="item.placeholder"
                                    style="width: 220px;" @change="(val) => item.change?.(val)" clearable>
                                    <template v-for="option in item.options" :key="option.value">
                                        <el-option :label="option.label" :value="option.value" />
                                    </template>
                                </el-select>
                            </template>
                            <template v-if="item.type === 'fetchSelect'">
                                <el-select v-model="searchForm[item.prop]" :placeholder="item.placeholder"
                                    style="width: 220px;" filterable @change="(val) => item.change?.(val)" clearable>
                                    <template v-for="option in item.options" :key="option.value">
                                        <el-option :label="option.label" :value="option.value" />
                                    </template>
                                </el-select>
                            </template>
                        </el-form-item>
                        <!-- </el-col> -->
                    </template>
                    <!-- 重置和搜索按钮 -->
                    <div class="btns">
                        <el-button :icon="Refresh" @click="handleResetClick">重置</el-button>
                        <el-button type="primary" :icon="Search" @click="handleQueryClick">搜索</el-button>
                        <el-button v-if="isShowExport === true" type="success" plain :icon="DocumentChecked"
                            @click="hanldeExportExcel" :disabled="isExporting">明细导出</el-button>
                        <el-button v-if="isShowSumExport === true" type="success" :icon="DocumentChecked"
                            @click="handleSummaryExport" :disabled="isExporting">汇总导出</el-button>
                    </div>
                </el-row>
            </el-form>
        </div>
    </el-card>
</template>

<script setup>
import { reactive, ref, defineEmits, defineProps, defineExpose } from 'vue'
import { Refresh, Search, DocumentChecked } from '@element-plus/icons-vue'
import { ElProgress } from 'element-plus'

const emit = defineEmits(['queryClick', 'resetClick', 'exportClick', 'summaryExportClick'])
const props = defineProps(['searchConfig', 'isShowExport', 'isShowSumExport'])

// 导出状态管理
const isExporting = ref(false) // 控制进度条显示/隐藏
const exportProgress = ref(0) // 进度百分比（0-100）

// 新增：重置导出状态的方法（供父组件调用）
const resetExportStatus = () => {
    isExporting.value = false
    exportProgress.value = 0 // 同时重置进度条
}


//定义form 数据
const initialForm = {}
for (const item of props.searchConfig.formItems) {
    initialForm[item.prop] = item.initialValue ?? ''
}
const searchForm = reactive(initialForm)

//重置表单
const formRef = ref()
function handleResetClick() {
    formRef.value?.resetFields()
    emit('resetClick', searchForm)
}

//查询表单
function handleQueryClick() {
    emit('queryClick', searchForm)
}

//导出Excel
function hanldeExportExcel() {
    // 通知父组件开始导出，并传递进度更新函数
    emit('exportClick', searchForm, (progress) => {
        isExporting.value = true
        exportProgress.value = progress
        // 进度100%时隐藏进度条
        if (progress >= 100) {
            setTimeout(() => {
                isExporting.value = false
                exportProgress.value = 0 // 重置进度
            }, 500) // 延迟0.5s让用户看到完成状态
        }
    })
}

// 新增：汇总导出处理函数
function handleSummaryExport() {
    // 通知父组件开始汇总导出，并传递进度更新函数
    emit('summaryExportClick', searchForm, (progress) => {
        isExporting.value = true
        exportProgress.value = progress
        // 进度100%时隐藏进度条
        if (progress >= 100) {
            setTimeout(() => {
                isExporting.value = false
                exportProgress.value = 0 // 重置进度
            }, 500) // 延迟0.5s让用户看到完成状态
        }
    })
}


// 暴露方法给父组件（关键）
defineExpose({
    resetExportStatus
})

</script>

<style lang="less" scoped>
.search {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    margin-top: 20px;

    .btns {
        margin-left: 30px;
        text-align: right;

    }
}

// 进度条样式
.export-progress {
    margin: 10px auto;
    width: 80%; // 进度条宽度
    padding: 0 20px;

    .progress-text {
        text-align: center;
        margin-top: 5px;
        color: #666;
        font-size: 14px;
    }
}
</style>